module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}


//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/browser/curves.json
// module id = 380
// module chunks = 1